import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, CreditCard, ShieldCheck, ArrowRight } from 'lucide-react';
export function FeesSection() {
  return <section id="fees" className="py-12 lg:py-16 bg-cream" data-id="element-190">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-192">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-193">
            Fees & Policies
          </h2>
          <p className="text-charcoal/70 text-base font-medium" data-id="element-194">
            Transparent pricing and flexible payment options.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-6" data-id="element-195">
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-196">
            <div className="bg-white rounded-xl p-6 border border-charcoal/10" data-id="element-197">
              <h3 className="font-heading text-lg font-bold text-charcoal mb-2" data-id="element-198">
                Individual Session
              </h3>
              <div className="flex items-baseline gap-1.5 mb-3" data-id="element-199">
                <span className="text-3xl font-bold text-olive" data-id="element-200">$150</span>
                <span className="text-charcoal/50 font-medium text-sm" data-id="element-201">
                  / 50 min
                </span>
              </div>
              <p className="text-charcoal/70 mb-4 text-sm font-medium" data-id="element-202">
                One-on-one therapy sessions focused on your personal goals and
                healing.
              </p>
              <ul className="space-y-2" data-id="element-203">
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-204">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-205" />
                  <span data-id="element-206">In-person or Telehealth</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-207">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-208" />
                  <span data-id="element-209">Personalized treatment plan</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-6 border-2 border-olive shadow-soft relative" data-id="element-210">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-olive text-white px-3 py-0.5 rounded-full text-xs font-bold tracking-wide uppercase" data-id="element-211">
                Most Common
              </div>
              <h3 className="font-heading text-lg font-bold text-charcoal mb-2" data-id="element-212">
                Couples Session
              </h3>
              <div className="flex items-baseline gap-1.5 mb-3" data-id="element-213">
                <span className="text-3xl font-bold text-olive" data-id="element-214">$180</span>
                <span className="text-charcoal/50 font-medium text-sm" data-id="element-215">
                  / 60 min
                </span>
              </div>
              <p className="text-charcoal/70 mb-4 text-sm font-medium" data-id="element-216">
                Joint sessions to improve communication and resolve relationship
                conflicts.
              </p>
              <ul className="space-y-2" data-id="element-217">
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-218">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-219" />
                  <span data-id="element-220">In-person or Telehealth</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-charcoal/80" data-id="element-221">
                  <CheckCircle2 size={16} className="text-olive flex-shrink-0 mt-0.5" data-id="element-222" />
                  <span data-id="element-223">Conflict resolution tools</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-4" data-id="element-224">
            <div className="bg-white rounded-xl p-6 border border-charcoal/10" data-id="element-225">
              <div className="flex items-center gap-3 mb-3" data-id="element-226">
                <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive" data-id="element-227">
                  <ShieldCheck size={20} data-id="element-228" />
                </div>
                <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-229">
                  Insurance Coverage
                </h3>
              </div>
              <p className="text-charcoal/70 text-sm mb-3 font-medium leading-relaxed" data-id="element-230">
                Services may be covered by your health insurance or employee
                benefit plan. I provide detailed receipts for reimbursement.
              </p>
              <p className="text-charcoal/80 text-sm font-bold" data-id="element-231">
                Check if your provider covers "Registered Psychotherapists".
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-charcoal/10" data-id="element-232">
              <div className="flex items-center gap-3 mb-3" data-id="element-233">
                <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive" data-id="element-234">
                  <CreditCard size={20} data-id="element-235" />
                </div>
                <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-236">
                  Payment & Policies
                </h3>
              </div>
              <ul className="space-y-2 text-sm text-charcoal/80 mb-4 font-medium" data-id="element-237">
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-238">
                  <span data-id="element-239">Accepted Methods</span>
                  <span className="font-bold" data-id="element-240">Credit Card, e-Transfer</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-241">
                  <span data-id="element-242">Cancellation Policy</span>
                  <span className="font-bold" data-id="element-243">48 hours notice</span>
                </li>
              </ul>
              <div className="bg-olive/10 p-3 rounded-lg" data-id="element-244">
                <h4 className="font-bold text-olive mb-1 text-xs uppercase tracking-wide" data-id="element-245">
                  Sliding Scale Available
                </h4>
                <p className="text-xs text-charcoal/70 font-medium leading-relaxed" data-id="element-246">
                  Limited spots available for those experiencing financial
                  hardship.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-247">
          <Link to="/fees" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all shadow-soft min-h-[48px] tracking-wide" data-id="element-248">
            View Full Pricing
            <ArrowRight size={16} className="ml-2" data-id="element-249" />
          </Link>
        </div>
      </div>
    </section>;
}